import React  from 'react';
import UserComponentProto from '../../components/user-proto';

export default function renderAssignedToInList(className, placeholder, props) {
    return <UserComponentProto renderValue="icon-name" className={className} renderMode="list" placeholder={placeholder} {...props} />;
}